import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import * as moduleState from './state'
import store from 'src/store'
import * as moduleSelectors from './selectors'
import { actions as moduleActions } from './actions'
import moduleSagas from './sagas'
import { builderSagaCommunications } from 'src/helpers/redux'
import { mergePresentedParticipants } from './adaptParticipants'

export const emailSlice = createSlice({
  name: moduleState.PREFIX,
  initialState: moduleState.initialState,
  reducers: {
    setDevice(
      state,
      action: PayloadAction<moduleState.IState['data']['device']>
    ) {
      state.data.device = action.payload
    },
    patchCall(
      state,
      action: PayloadAction<Partial<moduleState.IState['data']['call']>>
    ) {
      state.data.call = { ...state.data.call, ...action.payload }
    },
    setParticipants(
      state,
      action: PayloadAction<moduleState.IState['data']['participants']>
    ) {
      state.data.participants = action.payload
    },
    setCallSid(state, action: PayloadAction<string | null>) {
      state.data.callSid = action.payload
    },
    setBackendCall(
      state,
      action: PayloadAction<{
        call: moduleState.IBackendCall | null
        currentUserId?: number | null
      }>
    ) {
      const { call, currentUserId } = action.payload

      state.data.backendCall = call
      state.data.participants = call
        ? mergePresentedParticipants(
            state.data.participants,
            call.participants ?? [],
            { callSid: state.data.callSid, currentUserId }
          )
        : []
    },
    /** Call is over: back to "no call" */
    resetCall(state) {
      state.data.call = moduleState.initialCall
      state.data.callSid = null
      state.data.backendCall = null
      state.data.participants = []
    },
  },
  extraReducers: (builder) => {
    builderSagaCommunications(builder, moduleActions)
  },
})

export const reducers = { [moduleState.PREFIX]: emailSlice.reducer }
export const selectors = moduleSelectors
export const setters = emailSlice.actions
export const actions = moduleActions
export const sagas = moduleSagas

export const injectStore = () => {
  store.injectReducer?.(moduleState.PREFIX, emailSlice.reducer)
  store.injectSaga?.(moduleState.PREFIX, sagas)
}
